export class DispatchAndInvoiceResponseModel {
    outboundLoadUidK: number;
    bkLoadR: number;
    bkLoadedUserC: string;
    statusUidD: number;
    outboundCasesTO: OutboundCasesTO;
    outboundRoutesTO: OutboundRoutesTO;
    selectedFROM: boolean;
    enableToInvoice: string;
    statusTO: StatusTO;
	transportModalF: string;
	exportacaoF: string;
    totalGrossWeightA: number;
	commercialInvoice: string;

	constructor() {
		this.outboundCasesTO = new OutboundCasesTO();
		this.outboundRoutesTO = new OutboundRoutesTO();
		this.statusTO = new StatusTO();
	}
}

export class BaseDimensions{
    heightQ: number;
    depthQ: number;
    widthQ: number;
}

export class OutboundCasesTO extends BaseDimensions {
    outboundCaseUidK: number;
    bkCaseR: number;
    bulk_F: string;
    customers: Customers;
    outboundBatchUid: number;
    outboundRoutesUid: number;
    statusTO: StatusTO;
	subDivisionUidD: number;
    netWeightA: number;
    caseTypes: CaseTypes;
    grossWeightInformedA : number;
    sizeUnityOfMeasureC: string;
    weightUnitOfMeasureC: string;
	constructor() {
        super();
		this.customers = new Customers();
		this.statusTO = new StatusTO();
	}
}

export class CaseTypes extends BaseDimensions{
    bkCaseTypeC: string;
    sizeUnityOfMeasureC: string;
    pagination:any;
}

export class StatusTO {
    statusUidK: number;
    bkStatusR: number;
    statusN: string;
}

export class Customers {
    bkCustomerC: string;
    customerN: string;
}

export class OutboundRoutesTO {
    bkRouteC: string;
    routeX: string;
    outboundRouteXDealers: any[];
}

export class RootObject {

}



